import React from 'react'
import { useEffect, useState } from "react";
import Regua2024 from '../../../../components/Regua2024'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

const TabExecucaoOrcamentaria = (props) => {
  const [dadosOrcamFinan, setDadosOrcamFinan] = useState([]);
  const [porcentagemPrevistoInicial, setPorcentagemPrevistoInicial] = useState(0);
  const [porcentagemPrevistoAtualizado, setPorcentagemPrevistoAtualizado] = useState(0);

  const [totalOrcamFinan, setTotalOrcamFinan] = useState({
    codgFonte: "Total",
    vlrInicial: 0,
    vlrAtualizado: 0,
    vlrSuplementado: 0,
    vlrAnulado: 0,
    vlrContigenciadoBloqueado: 0,
    vlrEmpenhado: 0,
    vlrLiquidado: 0,
    vlrPpd: 0,
    vlrCofd: 0,
    vlrLiquidadoInicial: 0,
    vlrLiquidadoFinal: 0,
  });

  useEffect(() => {
    if(props.plan72RealizadoPrograma){
      var varOrcFinan = [...props.plan72RealizadoPrograma];
      setDadosOrcamFinan(varOrcFinan);

      var total = {
        codgFonte: "Total",
        vlrInicial: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrInicial.toFixed(2)), 0),
        vlrAtualizado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrAtualizado.toFixed(2)), 0),
        vlrSuplementado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrSuplementado.toFixed(2)), 0),
        vlrAnulado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrAnulado.toFixed(2)), 0),
        vlrContigenciadoBloqueado: varOrcFinan.reduce(
          (acc, current) => acc + parseFloat(current.vlrContigenciadoBloqueado.toFixed(2)),
          0
        ),
        vlrEmpenhado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrEmpenhado.toFixed(2)), 0),
        vlrLiquidado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrLiquidado.toFixed(2)), 0),
        vlrPpd: 0,
        vlrCofd: 0,
        vlrLiquidadoInicial: 0,
        vlrLiquidadoFinal: 0,
      };

      let vlrAtualizado = total.vlrAtualizado - total.vlrContigenciadoBloqueado;
      total.vlrPpd = total.vlrInicial != 0 ? (total.vlrEmpenhado / total.vlrInicial) * 100 : 0;
      total.vlrCofd = vlrAtualizado != 0 ? (total.vlrEmpenhado / vlrAtualizado) * 100 : 0;
      total.vlrLiquidadoInicial = total.vlrInicial != 0 ? (total.vlrLiquidado / total.vlrInicial) * 100 : 0;
      total.vlrLiquidadoFinal = total.vlrAtualizado != 0 ? (total.vlrLiquidado / total.vlrAtualizado) * 100 : 0;

      setTotalOrcamFinan(total);
      setPorcentagemPrevistoInicial(total.vlrPpd.toFixed(2));
      setPorcentagemPrevistoAtualizado(total.vlrCofd.toFixed(2));}

  }, []);

  function formatarValor(value) {
    let val = (value / 1).toFixed(2).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  let headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Fonte" rowSpan={2} />
        <Column header="Dotação" colSpan={2} headerStyle={{ textAlign: "center" }} />
        <Column header="Créditos Adicionais" colSpan={2} />
        <Column header="Contingenciado / Bloqueado (C)" rowSpan={2} />
        <Column header="Empenhado (D)" rowSpan={2} />
        <Column header="Liquidado (E)" rowSpan={2} />
        <Column header="Empenhado (%)" colSpan={2} />
        <Column header="Liquidado (%)" colSpan={2} />
      </Row>
      <Row>
        <Column header="Inicial(A)" />
        <Column header="Atualizada(B)" />
        <Column header="Suplementar" />
        <Column header="Redução / Anulação" />

        <Column header="PPD(%) (D/A)" />
        <Column header="COFD (%) (D/(B-C))" />
        <Column header="Inicial (%) (E/A)" />
        <Column header="Atualizada (%) (E/B)" />
      </Row>
    </ColumnGroup>
  );

  let footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer={totalOrcamFinan.codgFonte} />
        <Column footer={formatarValor(totalOrcamFinan.vlrInicial)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrAtualizado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrSuplementado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrAnulado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrContigenciadoBloqueado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrEmpenhado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrPpd)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrCofd)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidadoInicial)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidadoFinal)} />
      </Row>
    </ColumnGroup>
  );

  return (
    <>
        <Accordion multiple activeIndex={[0,1]}>
          <AccordionTab header="Realização Orçamentária e Financeiro da Ação">
            <DataTable
                  value={dadosOrcamFinan}
                  scrollable scrollHeight="650px" 
                  stripedRows
                  showGridlines
                  headerColumnGroup={headerGroup}
                  footerColumnGroup={footerGroup}
                  responsiveLayout="scroll"
                  emptyMessage="Não existem dados para exibição."
                >
                  <Column field="codgFonte" body={(e) => e.codgFonte} header="Fonte" />
                  <Column field="vlrInicial" body={(e) => formatarValor(e.vlrInicial)} header="Inicial(A)" />
                  <Column field="vlrAtualizado" body={(e) => formatarValor(e.vlrAtualizado)} header="Atualizada(B)" />
                  <Column field="vlrSuplementado" body={(e) => formatarValor(e.vlrSuplementado)} header="Suplementar" />
                  <Column field="vlrAnulado" body={(e) => formatarValor(e.vlrAnulado)} header="Redução / Anulação" />
                  <Column
                    field="vlrContigenciadoBloqueado"
                    body={(e) => formatarValor(e.vlrContigenciadoBloqueado)}
                    header="Contingenciado / Bloqueado (C)"
                  />
                  <Column field="vlrEmpenhado" body={(e) => formatarValor(e.vlrEmpenhado)} header="Empenhado (D)" />
                  <Column field="vlrLiquidado" body={(e) => formatarValor(e.vlrLiquidado)} header="Liquidado (E)" />
                  <Column field="vlrPpd" body={(e) => formatarValor(e.vlrPpd)} header="PPD(%) (D/A)" />
                  <Column field="vlrCofd" body={(e) => formatarValor(e.vlrCofd)} header="COFD (%) (D/(B-C))" />
                  <Column
                    field="vlrLiquidadoInicial"
                    body={(e) => formatarValor(e.vlrLiquidadoInicial)}
                    header="Inicial (%) (E/A)"
                  />
                  <Column
                    field="vlrLiquidadoFinal"
                    body={(e) => formatarValor(e.vlrLiquidadoFinal)}
                    header="Atualizada (%) (E/B)"
                  />
            </DataTable>
          </AccordionTab>
          <AccordionTab header="Análise do PPD e COFD">            
            <Regua2024 atributos={[{titulo:`PPD - Planejamento e Programação da Despesa`,porcentagemPrevisto:porcentagemPrevistoInicial},
                        {titulo:`COFD - Capacidade Operacional Financeira da Despesa`,porcentagemPrevisto:porcentagemPrevistoAtualizado}]} 
            />
          </AccordionTab>
        </Accordion>
    </>
  )
}

export default TabExecucaoOrcamentaria